import { useModel } from '@umijs/max';

export default function AvatarName() {
  const { initialState } = useModel('@@initialState');
  const { currentUser } = initialState || {};

  return <span>{currentUser?.username || '用户'}</span>;
}